import { useState, useEffect, useCallback } from "react";
import { login as loginApi, me } from "../lib/api";

// Simple JWT admin session backed by localStorage.
export function useAdmin() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("blokista_token");
    if (!t) { setAdmin(null); setLoading(false); return; }
    try {
      const u = await me();
      setAdmin(u);
    } catch {
      localStorage.removeItem("blokista_token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const doLogin = async (email, password) => {
    const r = await loginApi(email, password);
    localStorage.setItem("blokista_token", r.token);
    setAdmin(r.user);
    return r.user;
  };

  const doLogout = () => {
    localStorage.removeItem("blokista_token");
    setAdmin(null);
  };

  return { admin, loading, doLogin, doLogout, refresh };
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
